var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDragDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 2.15375C4.5 3.34325 3.60455 4.3075 2.5 4.3075C1.39545 4.3075 0.5 3.34325 0.5 2.15375C0.5 0.96427 1.39545 0 2.5 0C3.60455 0 4.5 0.96427 4.5 2.15375ZM2.5 11.3075C3.60455 11.3075 4.5 10.3433 4.5 9.15375C4.5 7.96425 3.60455 7 2.5 7C1.39545 7 0.5 7.96425 0.5 9.15375C0.5 10.3433 1.39545 11.3075 2.5 11.3075ZM2.5 18.3075C3.60455 18.3075 4.5 17.3433 4.5 16.1537C4.5 14.9642 3.60455 14 2.5 14C1.39545 14 0.5 14.9642 0.5 16.1537C0.5 17.3433 1.39545 18.3075 2.5 18.3075Z",
    fill: "#C5CEE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 2.15375C13.5 3.34325 12.6046 4.3075 11.5 4.3075C10.3954 4.3075 9.5 3.34325 9.5 2.15375C9.5 0.96427 10.3954 0 11.5 0C12.6046 0 13.5 0.96427 13.5 2.15375ZM11.5 11.3075C12.6046 11.3075 13.5 10.3433 13.5 9.15375C13.5 7.96425 12.6046 7 11.5 7C10.3954 7 9.5 7.96425 9.5 9.15375C9.5 10.3433 10.3954 11.3075 11.5 11.3075ZM11.5 18.3075C12.6046 18.3075 13.5 17.3433 13.5 16.1537C13.5 14.9642 12.6046 14 11.5 14C10.3954 14 9.5 14.9642 9.5 16.1537C9.5 17.3433 10.3954 18.3075 11.5 18.3075Z",
    fill: "#C5CEE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDragDrop);
export default __webpack_public_path__ + "static/media/icon-drag-drop.de22e54fbba3bbad5e9e81b60d877d7a.svg";
export { ForwardRef as ReactComponent };